<template>
  <b-card no-body class="mt-6">
    <!-- modal-content-classes="cust-modal-ht" -->
    <b-modal
      header-bg-variant="primary"
      header-text-variant="white"
      id="modal-6"
      title="Reason for Rejection"
      hide-footer
      hide-header
      modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey flex justify-center"
      class="overflow-y-hidden"
    >
      <div class="flex justify-between items-center pb-4">
        <p class="text-xl font-semibold">Reason for Rejection</p>
        <!-- <img
          src="../../../../assets/images/cross.png"
          class="h-8 w-8 cursor-pointer"
          alt="cross"
          v-b-modal.editModal
        /> -->
      </div>
      <div class="mb-4">
        <p class="input-title text-black">Description</p>
        <b-input
          v-model="reason"
          placeholder="Enter feature description"
          class="md:border-0 lg:border-0 custipshadow"
          name="Description"
        ></b-input>
        <!-- :rules="{ required: true }" -->
      </div>
      <div class="flex justify-center">
        <b-button type="submit" variant="primary" @click="handleReject"
          >Save</b-button
        >
        <b-button type="submit" variant="primary" @click="closeModal('modal-6')"
          >Close</b-button
        >
      </div>
    </b-modal>
    <div class="flex mt-12 mb-12">
      <AcceptApplicationreqtablePopup
        :isActiveAccept="isApplicationAccept"
        :AcceptAppplicationreq="AcceptAppplicationreq"
        @close="AcceptApplicationsDetails"
      />
      <RejectApplicationreqtablePopup
        :isActiveReject="isApplicationReject"
        :RejectAppplicationreq="RejectAppplicationreq"
        @close="RejectApplicationsDetails"
      />
      <ActionViewpopup
        :isActiveView="isApplicationView"
        :ViewApplicationreq="ViewApplicationreq"
        @close="openThisPopup"
      />

      <div class="w-full mr-4">
        <b-input-group class="">
          <b-form-input
            class="border-none shadow-lg ml-4"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
            v-model="search"
            @input="getVolunteer"
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
              @click="getVolunteer"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-color"
      :data="user"
      border
    >
      <el-table-column
        label="Sr. no"
        min-width="100px"
        prop="srno"
        sortable
      ></el-table-column>
      <el-table-column label="Name" min-width="180px" prop="name" sortable>
      </el-table-column>
      <el-table-column
        label="Phone Number"
        prop="mobile"
        min-width="150px"
        sortable
      >
      </el-table-column>

      <el-table-column label="Email ID" prop="email" min-width="180px" sortable>
      </el-table-column>

      <el-table-column
        label="Status"
        min-width="300px"
        prop="isReject"
        sortable
      >
        <div class="flex" slot-scope="scope" v-if="scope.row.isReject === true">
          <p>Rejected</p>
        </div>
        <div class="flex" slot-scope="scope" v-else>
          <base-button
            type="primary"
            class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
            @click="AcceptApplicationsDetails(true, scope.row)"
          >
            Approve
          </base-button>
          <base-button
            type="primary"
            class="px-6 py-1 mx-1 flex items-center h-10 ml-4 bg-FF3D3D"
            @click="RejectApplicationsDetails(true, scope.row)"
          >
            Reject
          </base-button>
        </div>
      </el-table-column>

      <el-table-column label="Action" min-width="150px" prop="_id" sortable>
        <div slot-scope="scope">
          <base-button
            type="primary"
            class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
            @click="openThisPopup(true, scope.row._id)"
          >
            View
          </base-button>
          <!-- {{ scope.row._id }} -->
        </div>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <!-- <base-pagination
        @change="
          (value) => {
            currentPage = value;
            dataload();
          }
        "
        :per-page="perPage"
        :total="total_row"
      ></base-pagination> -->
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
      ></b-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
// import projects from "./projects";
import RejectApplicationreqtablePopup from "./reject-applicationreqPopup.vue";
import AcceptApplicationreqtablePopup from "./accept-applicationreqPopup.vue";
import ActionViewpopup from "./ActionViewpopup.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import { mapState } from "vuex";

export default {
  name: "light-table",
  components: {
    AcceptApplicationreqtablePopup,
    RejectApplicationreqtablePopup,
    ActionViewpopup,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      reason: "",
      rejectPayload: {},
    };
  },
  watch: {
    async currentPage() {
      await this.getVolunteer();
    },
  },
  methods: {
    async AcceptApplicationsDetails(val = false, item = {}) {
      this.isApplicationAccept = val;
      this.AcceptAppplicationreq = item;

      let payload = {};

      if (this.AcceptAppplicationreq._id && this.AcceptAppplicationreq.userId) {
        payload = {
          _id: this.AcceptAppplicationreq._id,
          userId: this.AcceptAppplicationreq.userId,
          role: "volunteer",
          adminApproval: true,
        };
        try {
          const data = await this.$store.dispatch(
            "respitecare/update_statusvolunteer",
            payload
          );
          if (data) {
            let emailPayload = {
              email: this.AcceptAppplicationreq.email,
            };
            let acceptEmail = await this.$store.dispatch(
              "respitecare/email_acceptvolunteer",
              emailPayload
            );
            // console.log(acceptEmail);
          }

          await this.getVolunteer();
          await this.$store.dispatch("respitecare/get_all_count");
        } catch (error) {}
      }
    },
    async RejectApplicationsDetails(val = false, item = {}) {
      this.$bvModal.show("modal-6");
      this.RejectAppplicationreq = item;

      // let payload = {};

      if (this.RejectAppplicationreq._id && this.RejectAppplicationreq.userId) {
        this.rejectPayload = {
          _id: this.RejectAppplicationreq._id,
          userId: this.RejectAppplicationreq.userId,
          isReject: true,
          adminApproval: false,
          isActive: false,
          email: this.RejectAppplicationreq.email,
        };
        try {
        } catch (error) {}
      }
    },
    async handleReject() {
      try {
        Object.assign(this.rejectPayload, { reason: this.reason });
        this.$bvModal.hide("modal-6");
        this.isApplicationReject = true;
        const data = await this.$store.dispatch(
          "respitecare/update_statusvolunteer",
          this.rejectPayload
        );
        if (data) {
          let emailPayload = {
            email: this.rejectPayload.email,
          };
          let rejectEmail = await this.$store.dispatch(
            "respitecare/email_rejectvolunteer",
            emailPayload
          );
        }
        await this.getVolunteer();
        await this.$store.dispatch("respitecare/get_all_count");
      } catch (error) {}
    },
    async getVolunteer() {
      // let payload = {};
      let curPage = this.currentPage - 1;

      let payload = {
        limit: this.perPage,
        offset: curPage,
        isAdminApprove: false,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        await this.$store.dispatch(
          "respitecare/get_volunteer_by_admin",
          payload
        );
        await this.$store.dispatch("respitecare/get_all_count");
        const data = this.get_volunteer_by_admin;

        this.totalRows = data[0].totalCount;
        let userdata = data[0].result;
        const users = userdata.map((user, index) => {
          if (user.userId[0]) {
            return {
              srno: index + 1 + curPage * this.perPage,
              name: user.userId[0].firstname ? user.userId[0].firstname : "",
              mobile: user.userId[0].mobile ? user.userId[0].mobile : "",
              email: user.userId[0].email ? user.userId[0].email : "",
              role: "Approve,Reject",
              _id: user._id ? user._id : "",
              userId: user.userId[0]._id ? user.userId[0]._id : "",
              socialmediaId: user.socialMedia ? user.socialMedia : "",
              isReject: user.isReject,
            };
          }
        });
        this.user = users;
      } catch (error) {
        console.log(error);
      }
    },
    async openThisPopup(val = false, data = null) {
      if (val) await this.ViewApplicationsDetails(data);
      if (!val) this.ViewApplicationreq = {};
      this.isApplicationView = val;
    },
    async ViewApplicationsDetails(id) {
      // this.ViewApplicationreq = item;
      let payload = {
        volunteerId: id,
        noAdminRequired: true,
      };
      const { data } = await this.$store.dispatch(
        "respitecare/get_volunteerbyid",
        payload
      );
      // console.log("ViewApplicationreq", data);
      this.ViewApplicationreq = data;
    },
    closeModal(name) {
      this.reason = "";
      this.$bvModal.hide(name);
    },
  },
  computed: {
    toggled() {
      return this.userToggle;
    },
    ...mapState("respitecare", ["get_volunteer_by_admin"]),
  },
  data() {
    return {
      userToggle: false,
      AcceptAppplicationreq: {},
      RejectAppplicationreq: {},
      ViewApplicationreq: {},
      isApplicationAccept: false,
      isApplicationReject: false,
      isApplicationView: false,
      //   projects,
      currentPage: 1,
      search: "",
      user: [
        // {
        //   srno: 1,
        //   name: "megha",
        //   mobile: 9874563214,
        //   email: "bhagirathmegha@gmail.com",
        //   role: "Active, Reject",
        //   socialmediaId: 123456,
        // },
      ],
      totalRows: 0,
      perPage: 5,
    };
  },
  async mounted() {
    await this.getVolunteer();
    // console.log(this.users);
  },
};
</script>

<style>
.bg-FF3D3D {
  background: #ff3d3d !important;
}
</style>
